import { Tooltip } from "@mui/material";
import { FC } from "react";
import { RiRecordCircleFill } from "react-icons/ri";
import styled, { css } from "styled-components";
import { useContext } from "use-context-selector";
import { ExternalContext } from "../../context/ExternalContext";
import { useRoom } from "../../hooks/useRoom";
import { useVideoChat } from "../../hooks/useVideoChat";
import { getReadableColor } from "../helpers/getReadableColor";

const HeaderWrapper = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${(props) => getReadableColor(props.theme, "header")};
  background-color: ${(props) => props.theme.colors.header || "transparent"};
  box-shadow: ${(props) =>
    props.theme.colors.header ? "0 0 8px rgba(0,0,0,0.8)" : "none"};
`;

const HeaderTitle = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Title = styled("span")`
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding-left: 0.25rem;
`;

const RecordingIcon = styled("span")`
  @keyframes blink {
    from {
      color: #f5f5f5;
    }
    to {
      color: rgb(221, 7, 7);
    }
  }
  display: flex;
  align-items: center;
  .icon {
    animation-name: blink;
    animation-duration: 1s;
    animation-direction: alternate;
    animation-delay: 2s;
    animation-iteration-count: infinite;
  }
`;

const HelpButton = styled("div")`
  display: flex;
  align-items: center;
  user-select: none;
  padding-right: 0.25rem;
  span {
    font-size: 0.95rem;
    margin-right: 5px;
    font-weight: 400;
  }

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

interface IAppHeaderProps {
  handleOpen: () => void;
}

const AppHeader: FC<IAppHeaderProps> = ({ handleOpen }) => {
  const { isRecording } = useRoom();
  const { homePage } = useContext(ExternalContext);
  const { permission } = useVideoChat();

  return (
    <HeaderWrapper>
      <HeaderTitle>
        {isRecording && (
          <Tooltip title={"Essa telemedicina está sendo gravada"} arrow>
            <RecordingIcon>
              <RiRecordCircleFill size={25} className="icon" />
            </RecordingIcon>
          </Tooltip>
        )}
      </HeaderTitle>
      {!homePage && permission !== "professional" && (
        <HelpButton onClick={handleOpen}>
          <span>Ajuda</span>
        </HelpButton>
      )}
    </HeaderWrapper>
  );
};

export default AppHeader;
